<template>
  <div class="banner">
    <img v-if="isOne" :src="slides" class="img-fluid" alt="" style="width: 100%;"/>
    <div v-else class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="slide in slides" :key="slide.src">
          <img :src="slide.src" />
        </div>
      </div>
      <!-- 分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import defaultImag from "../assets/images/banner/jslc1.png";
import "swiper/dist/css/swiper.min.css";
export default {
  name: "banner",
  props: {
    slides: {
      type: [Array, String],
      default() {
        return [{ src: defaultImag }];
      }
    }
  },
  data() {
    return {
      swiper: null,
      isOne: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let type = typeof this.slides;
      if (type === "string") {
        this.isOne = true;
      } else {
        this.isOne = false;
        this.swiper = new Swiper(".swiper-container", {
          loop: true,
          speed: 2000,
          grabCursor: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          // 如果需要分页器
          pagination: {
            el: ".swiper-pagination"
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  display: block;
  //   height: 900px;
  width: 100%;
  .swiper-slide {
    color: white;
    img {
      max-width: 100%;
    }
  }
  .swiper-pagination-bullet-active {
    color: #fff;
  }
}
</style>
